module.exports = __webpack_public_path__ + "media/images/fine-wine-bottle-8cf4438fd0d5693e084835fa175b3124.webp";